import { Component, Input } from '@angular/core';
import { BaseViewComponent } from 'src/app/modules/my-account/components/base-view-edit-components/base-view/base-view.component';

@Component({
  selector: 'mpp-hipaa-authorization-view',
  templateUrl: './hipaa-authorization-view.component.html',
  standalone: false,
})
export class HipaaAuthorizationViewComponent extends BaseViewComponent {
  @Input() hipaaConsented: boolean;
}
